"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.process = void 0;
// eslint-disable-next-line import/prefer-default-export
const process = rulesObj => Object.entries(rulesObj).reduce((acc, [name, val]) => {
    if (val || typeof val === 'number') {
        acc[`--${name}`] = val;
    }
    return acc;
}, {});
exports.process = process;
